module.exports = __webpack_public_path__ + "static/media/documentreference.js.045cbe0c.map";